import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    width: 360,

    position: "sticky",
    bottom: 0,

    backgroundColor: "#ffffff",
  },
  messagesIconContainer: {
    width: 40,
    height: 40,
  },
  messageRing: {
    width: 40,
    height: 40,
  },
  manyMessagesRemain: {
    color: theme.colors.clearGreen
  },
  halfMessagesRemain: {
    color: theme.colors.clearYellow
  },
  lowMessagesRemain: {
    color: theme.colors.clearRed
  },
  noMessagesRemain: {
    color: theme.colors.grey1
  },
  expander: {
    height: 22,

    marginRight: 12,

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    color: theme.colors.grey5,
    ...theme.typography.txtBody2,
    fontWeight: "bold"
  },
  upsideDown: {
    "-moz-transform": "scaleY(-1)",
    "-o-transform": "scaleY(-1)",
    "-webkit-transform": "scaleY(-1)",
    transform: "scaleY(-1)",
  },
  messagesFirstRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 5,

    height: 72,
  },
  messagesFirstRowText: {
    width: 270,
    height: 34,

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    ...theme.typography.txtBody1,
    color: theme.colors.grey5,
    fontWeight: 700,
  },
  firstRowExpandedBorder: {
    borderBottom: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "rgba(201, 205, 211, 0.5)",
  },
  messagesText: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    height: 28,

    ...theme.typography.txtBody2,
    color: theme.colors.grey6,
  },
  divider: {
    width: 270,
    height: 0,

    borderBottom: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "rgba(201, 205, 211, 0.5)",
  },
  })
);

export default useStyles;